import PropTypes from 'prop-types'
import React from 'react'
import { getCurrentAd } from 'src/modules/ads/detail/selectors'
import { connect } from 'react-redux'
import config from 'SRC/config/config.yaml'

const getSortedYears = years => {
  return years.map(year => Number(year)).slice().sort((y1, y2) => y1 - y2).join(', ')
}

const getYearsRange = years => {
  const min = Math.min(...years.map(year => Number(year)))
  const max = Math.max(...years.map(year => Number(year)))
  return min === max ? min : `${min} - ${max}`
}

class Compatibilities extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      showYears: {},
      showModels: {}
    }
  }

  componentDidMount () {
    this.initState()
  }

  componentDidUpdate (prevProps) {
    if (prevProps.ad && this.props.ad.seo !== prevProps.ad.seo) this.initState()
  }

  initState () {
    const { ad } = this.props

    if (ad && ad.compatibilitiesNew && ad.compatibilitiesNew.length) {
      const showYears = {}
      const showModels = {}

      const compatibilities = ad.compatibilitiesNew[0]
      if (compatibilities.brands && compatibilities.brands.length) {
        if (compatibilities.brands.length === 1) {
          if (compatibilities.brands[0].products && compatibilities.brands[0].products.length) {
            showModels[compatibilities.brands[0].name] = true
          } else {
            showModels[compatibilities.brands[0].name] = false
          }
        } else {
          for (const compatibilityBrand of compatibilities.brands) {
            showModels[compatibilityBrand.name] = false
          }
        }
        for (const compatibilityBrand of compatibilities.brands) {
          if (compatibilityBrand.years) {
            showYears[compatibilityBrand.name] = false
          }
          if (compatibilityBrand.products) {
            for (const compatibilityProduct of compatibilityBrand.products) {
              if (compatibilityProduct.years) {
                showYears[compatibilityProduct.name] = false
              }
            }
          }
        }
      }

      this.setState({ showYears, showModels })
    }
  }

  showMoreYears = name => {
    this.setState({
      showYears: {
        ...this.state.showYears,
        [name]: true
      }
    })
  }

  showLessYears = name => {
    this.setState({
      showYears: {
        ...this.state.showYears,
        [name]: false
      }
    })
  }

  showModels = brand => {
    this.setState({
      showModels: {
        ...this.state.showModels,
        [brand]: true
      }
    })
  }

  hideModels = brand => {
    this.setState({
      showModels: {
        ...this.state.showModels,
        [brand]: false
      }
    })
  }

  renderToggleProductsButton = brand => {
    return !this.state.showModels[brand.name] ? <button className='compatibility-years-btn'
      onClick={() => this.showModels(brand.name)}>
      PRIKAŽI MODELE
    </button> : <button className='compatibility-years-btn'
      onClick={() => this.hideModels(brand.name)}>
      SAKRIJ
    </button>
  }

  renderYears = item => {
    const years = item.years && item.years.length ? item.years : null
    if (years) {
      return this.state.showYears[item.name]
        ? <span>{getSortedYears(years)}&emsp;
          <button className='compatibility-years-btn' onClick={() => this.showLessYears(item.name)}>
            PRIKAŽI MANJE
          </button>
        </span>
        : <span>{getYearsRange(years)}&emsp;
          <button className='compatibility-years-btn' onClick={() => this.showMoreYears(item.name)}>
            PRIKAŽI VIŠE
          </button>
        </span>
    } else {
      return null
    }
  }

  renderProducts = brand => {
    return this.state.showModels[brand.name] && brand.products && brand.products.length ? <React.Fragment>
      {brand.products.map(product => <li className='oglasi-kompatibilnosti-product'>
        <img src='/icons/enter.svg' />
        <p key={`${brand.name}_${product.name}`}>{product.name}</p>
        {this.renderYears(product)}
      </li>)}
    </React.Fragment> : null
  }

  renderCompatibilityItem = brand => {
    const products = brand.products && brand.products.length ? brand.products : null
    return <div className='oglasi-kompatibilnosti-item'>
      <li>
        <p>{brand.logo
          ? <img src={`${config.mediaCDN}${brand.logo}`} alt={brand.name} width={40} />
          : null} {brand.name}</p>
        {products ? this.renderToggleProductsButton(brand) : this.renderYears(brand)}
      </li>
      {this.renderProducts(brand)}
    </div>
  }

  renderCompatibilities = () => {
    const compatibilities = this.props.ad.compatibilitiesNew[0]

    if (compatibilities.brands) {
      if (compatibilities.brands.length < 1) {
        return null
      } else if (compatibilities.brands.length === 1) {
        const brand = compatibilities.brands[0]
        return this.renderCompatibilityItem(brand)
      } else {
        return compatibilities.brands.map(brand => this.renderCompatibilityItem(brand))
      }
    }
    return null
  }

  render () {
    const { ad } = this.props
    if (ad && ad.compatibilitiesNew && ad.compatibilitiesNew.length) {
      return <React.Fragment>
        <div className='oglasi-info-heading'>
          <p>Kompatibilnosti</p>
        </div>
        <ul className='oglasi-kompatibilnosti'>
          <li><p>Za kategoriju:</p><span>{ad.compatibilitiesNew[0].category}</span></li>
          <br />
          {this.renderCompatibilities()}
        </ul>
      </React.Fragment>
    }
    return null
  }
}

const mapStateToProps = state => ({
  ad: getCurrentAd(state)
})

Compatibilities.propTypes = {
  ad: PropTypes.shape({
    seo: PropTypes.string.isRequired,
    compatibilitiesNew: PropTypes.array
  })
}

Compatibilities.defaultProps = {
}

export default connect(mapStateToProps)(Compatibilities)
